module.exports = __webpack_public_path__ + "a7dc72a8c2b45db48d362f3be2f1928d.MP3";